import { useQueryClient } from '@tanstack/react-query';
import type { OsobyKomunikacniUdajeDto } from '@gov-nx/api';
import {
	rosCommunicationQueryKey,
	useRosCommunicationQuery,
} from '@gov-nx/core/hooks';
import type { Optional } from '@gov-nx/core/types';
import { is, propEq } from '@gov-nx/core/types';

export const useROSCommunicationQuery = () => {
	const queryClient = useQueryClient();

	const query = useRosCommunicationQuery({
		retry: 1,
		refetchOnWindowFocus: false,
	});

	const getRosContact = (ico: number): Optional<OsobyKomunikacniUdajeDto> =>
		query.data?.seznam?.filter(is).find(propEq('ico', ico))?.komunikacniUdaje ??
		undefined;

	return {
		...query,
		getRosContact,
		invalidate: async () =>
			queryClient.invalidateQueries({ queryKey: rosCommunicationQueryKey }),
	};
};
